import Lightbox from "react-image-lightbox";
import React, {useState} from "react";
import {Image, Loader, Visibility} from "semantic-ui-react";
import styled from 'styled-components';

export const LightBoxImage = ({title, ...props}) => {
    const [isOpen, setIsOpen] = useState(false);

    return <>
        {title.imageUrl &&
            <ImageStyled
                loading="lazy"
                src={title.imageUrl}
                width={title.width}
                height={title.height}
                onClick={() => setIsOpen(true)}
                alt={title.title}
                {...props}
            />
        }
        {isOpen && title.imageUrl && (
            <Lightbox
                mainSrc={title.imageUrl}
                onCloseRequest={() => setIsOpen(false)}
                onImageLoad={() => {
                    window.dispatchEvent(new Event('resize'));
                }}
            />
        )}
    </>
}

const ImageStyled = styled(Image)`
  width: auto;
  height: auto;
  cursor: pointer;
`
